import React, { useState } from 'react';
import { useWebSocket } from './useWebSocket';
import { biometricInstance } from '../../App';
import axios from 'axios';

const fn = () => {};

export function useBiometrics({
	onMessage = fn,
	onOpen = fn,
	onClose = fn,
	onError = fn
}) {
	const [biometricos, setBiometricos] = useState([]);
	const [biometricsState, setBiometricsState] = useState([]);

	const getData = (axiosData) => {
		if (typeof axiosData === 'string') {
			return JSON.parse(axiosData);
		}
		return axiosData;
	};

	const getBiometrics = async () => {
		try {
			const biometricos = await biometricInstance({
				method: 'GET',
				url: '/'
			});
			const data = getData(biometricos.data);
			setBiometricos([...data.data]);
		} catch (e) {
			console.error('Ocurrió un error al obtener la lista de biométricos');
		}
	};

	const onMessageFunction = (msg) => {
		const parsedMessage = JSON.parse(msg.data);
		onMessage(parsedMessage);
	};

	const onOpenFunction = (msg) => {
		getBiometrics();
		return onOpen(msg);
	};

	const onCloseFunction = (msg) => {
		return onClose(msg);
	};

	const onErrorFunction = (msg) => {
		return onError(msg);
	};

	useWebSocket({
		websocketUrl:
			process.env.REACT_APP_BIOMETRICS_WS_URL ||
			'ws://localhost:9000/biometrics/ws',
		onMessage: onMessageFunction,
		onOpen: onOpenFunction,
		onClose: onCloseFunction,
		onError: onErrorFunction
	});

	const iniciarCaptura = async (biometric_id, data) => {
		try {
			const result = await biometricInstance({
				method: 'POST',
				url: `${biometric_id}/captura`,
				data
			});
			return { isError: false, status: result.status, data: result.data };
		} catch (e) {
			if (axios.isCancel(e)) {
				throw {
					isError: true,
					status: 'canceled'
				};
			}
			throw {
				isError: true,
				status: e.response.status,
				error: e.response.data?.errMsg
			};
		}
	};

	return {
		biometricos,
		iniciarCaptura,
		biometricsState,
		setBiometricsState
	};
}
